import styled from 'styled-components';
import Colors from 'assets/Colors';
import Constants from 'helpers/constants';

const PageContainer = styled.div`
  display: flex;
  height: 100%;
  margin: 10px 10px;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    flex-direction: column;
  }
`;

const LeftContainer = styled.div`
  margin-right: 58px;
  // margin-left: 15px;
  width: 62%;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    margin-right: 0px;
    width: 100%;
  }
`;
const RightContainer = styled.div`
  width: 38%;
  @media (max-width: ${Constants.pxBreakPoint}px) {
    margin-top: 0px;
    width: 100%;
  }
`;

const CopyrightText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

const DLOEuropeText = styled.b`
  color: ${Colors.text_primary};
  font-weight: 500;
`;

const WrapperResponsive = styled.div`
  @media (max-width: ${Constants.pxBreakPoint}px) {
    display: none;
  }
`;

const loadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

export default {
  PageContainer,
  LeftContainer,
  RightContainer,
  CopyrightText,
  DLOEuropeText,
  WrapperResponsive,
  loadingContainer,
};
